import {Component, inject, OnInit} from '@angular/core';
import {PackService} from '../../../services/pack.service';
import {Observable} from 'rxjs';
import {PagedList} from '../../../models/entity.model';
import {PackModel} from '../../../models/pack.model';
import {RouterLink} from '@angular/router';
import {PageComponent, PageHeaderButtonsDirective} from '../../shared/page/page.component';
import {EntityListComponent} from '../../shared/entity-list/entity-list.component';
import {ButtonComponent} from '../../shared/button/button.component';
import {RoleService} from '../../../services/role.service';

@Component({
  selector: 'app-packs-page',
  imports: [
    RouterLink,
    PageComponent,
    PageHeaderButtonsDirective,
    EntityListComponent,
    ButtonComponent
  ],
  templateUrl: './packs-page.component.html',
  styleUrl: './packs-page.component.scss',
  host: {
    class: 'app-container'
  }
})
export class PacksPageComponent implements OnInit {
  protected readonly packService = inject(PackService)
  protected readonly roleService = inject(RoleService)
  protected packs!: Observable<PagedList<PackModel>>

  ngOnInit(): void {
    this.packs = this.packService.list()
  }
}
